<template>
  <header id="nav">
    <nav class="docs-navbar">
      <div class="container">
        <div class="container-div"></div>
        <ul>
          <li>
            <a
              href="https://docs.opentrons.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-gtm-category="p-toolbar"
              data-gtm-label="opentrons-api"
              data-gtm-action="click"
            >Python API</a>
          </li>
          <li>
            <a
              href="https://labware.opentrons.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-gtm-category="p-toolbar"
              data-gtm-label="labware-library"
              data-gtm-action="click"
            >Labware Library</a>
          </li>
          <li>
            <a
              href="https://protocols.opentrons.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-gtm-category="p-toolbar"
              data-gtm-label="protocol-library"
              data-gtm-action="click"
            >Protocol Library</a>
          </li>
          <li>
            <a
              href="https://designer.opentrons.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-gtm-category="p-toolbar"
              data-gtm-label="protocol-designer"
              data-gtm-action="click"
            >Protocol Designer</a>
          </li>
        </ul>
      </div>
    </nav>
    <nav class="navbar">
      <div class="container">
        <div class="navbar-container">
          <div class="navbar-logo" @click="close">
            <a
              href="https://opentrons.com/"
              class="brand"
              title="Home"
              data-gtm-category="p-header"
              data-gtm-label="logo"
              data-gtm-action="click"
            >
              <img
                class="logo"
                src="https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png"
                alt="Opentrons Home"
              >
            </a>
          </div>
          <div class="schedule-menu mobile-schedule-menu">
            <div class="schedule-div">
              <a
                class="btn schedule-demo"
                href="https://opentrons.com/contact"
                target="_blank"
                rel="noopener noreferrer"
                data-gtm-category="p-header"
                data-gtm-label="contact-sales"
                data-gtm-action="click"
              >Contact sales</a>
            </div>
            <div class="mobile-hamburger" :class="{open: open}">
              <div id="nav-collapse" @click="toggleOpen">
                <div class="bar1"></div>
                <div class="bar2"></div>
                <div class="bar3"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-menu" v-click-outside="closeOutside">
          <ul class="main-menu">
            <li class="main-menu-li about" @click="toggleMenu(`about`), isActive(`about`)">
              <span class="menu-span" :class="{notActive: active.about}">About</span>
              <ul id="about" class="navbar-ul" :class="{visible: !nav.about}">
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="about"
                    data-gtm-action="click"
                  >Mission</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/team"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="team"
                    data-gtm-action="click"
                  >Our Team</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://blog.opentrons.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="blog"
                    data-gtm-action="click"
                  >Blog</a>
                </li>
              </ul>
            </li>
            <li class="main-menu-li" @click="toggleMenu(`products`), isActive(`products`)">
              <span class="menu-span" :class="{notActive: active.products}">Products</span>
              <ul class="navbar-ul" id="products" :class="{visible: !nav.products}">
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/ot-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="ot-2"
                    data-gtm-action="click"
                  >OT-2 Robot</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/modules"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="tempmod"
                    data-gtm-action="click"
                  >OT-2 Temp Module</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/modules#magnetic_module"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="magmod"
                    data-gtm-action="click"
                  >OT-2 Magnetic Module</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/pipettes"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="ot-2-pipettes"
                    data-gtm-action="click"
                  >OT-2 Pipettes</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://shop.opentrons.com/collections/opentrons-tips"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="tips"
                    data-gtm-action="click"
                  >Pipette Tips</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://shop.opentrons.com/collections/racks-and-adapters"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="tube-racks"
                    data-gtm-action="click"
                  >Racks &amp; Adapters</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://shop.opentrons.com/collections/mag-bead-kits"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="reagents"
                    data-gtm-action="click"
                  >Reagents</a>
                </li>
                <a
                  @click="closeMenu"
                  class="blue blue-products"
                  href="https://shop.opentrons.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="all-products"
                  data-gtm-action="click"
                >Shop all products ›</a>
              </ul>
            </li>
            <li class="main-menu-li" @click="toggleMenu(`applications`), isActive(`applications`)">
              <span class="menu-span" :class="{notActive: active.applications}">Applications</span>
              <ul class="navbar-ul" id="applications" :class="{visible: !nav.applications}">
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/pcr-sample-prep"
                    data-gtm-category="p-header"
                    data-gtm-label="prep"
                    data-gtm-action="click"
                  >PCR Sample Prep</a>
                </li>
                <li @click="closeMenu">
                  <a
                    href="https://opentrons.com/nucleic-acid-cleanup"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="nac"
                    data-gtm-action="click"
                  >Nucleic Acid Cleanup</a>
                </li>
                <li @click="closeMenu">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://protocols.opentrons.com/categories/Sample%20Prep/PCR"
                    data-gtm-category="p-header"
                    data-gtm-label="qpcr"
                    data-gtm-action="click"
                  >qPCR/RT-PCR</a>
                </li>
                <li @click="closeMenu">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25"
                    data-gtm-category="p-header"
                    data-gtm-label="elisa"
                    data-gtm-action="click"
                  >ELISA</a>
                </li>
                <li @click="closeMenu">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://protocols.opentrons.com/categories/NGS%20Library%20Prep"
                    data-gtm-category="p-header"
                    data-gtm-label="ngs-prep"
                    data-gtm-action="click"
                  >NGS Library Prep</a>
                </li>
                <li @click="closeMenu">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://protocols.opentrons.com/categories/Basic%20Pipetting"
                    data-gtm-category="p-header"
                    data-gtm-label="basic"
                    data-gtm-action="click"
                  >Basic Pipetting</a>
                </li>
              </ul>
            </li>
            <li class="main-menu-li" @click="toggleMenu(`protocols`), isActive(`protocols`)">
              <span class="menu-span" :class="{notActive: active.protocols}">Protocols</span>
              <ul class="navbar-ul protocol-nav" id="protocols" :class="{visible: !nav.protocols}">
                <div class="navbar-ul-div">
                  <div class="protocol-items">
                    <li @click="closeMenu">
                      <a
                        href="https://opentrons.com/protocols"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="protocol-tools"
                        data-gtm-action="click"
                      >Protocol Options</a>
                      <span>Gain an overview of our protocol creation options</span>
                    </li>
                    <li @click="closeMenu">
                      <a
                        href="https://opentrons.com/protocols/designer"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="protocol-designer"
                        data-gtm-action="click"
                      >Protocol Designer</a>
                      <span>Use our graphical user interface to design protocols</span>
                    </li>
                    <li class="protocol-bottom" @click="closeMenu">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://protocols.opentrons.com"
                        data-gtm-category="p-header"
                        data-gtm-label="protocol-library"
                        data-gtm-action="click"
                      >Protocol Library</a>
                      <span>Explore our open source database of protocols</span>
                    </li>
                  </div>
                  <div class="protocol-items">
                    <li class="protocol-items-li" @click="closeMenu">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://docs.opentrons.com/"
                        data-gtm-category="p-header"
                        data-gtm-label="opentrons-api"
                        data-gtm-action="click"
                      >Python API</a>
                      <span class="protocol-items-span">
                        Maximum customization for anyone with python and basic
                        wetlab skills
                      </span>
                    </li>
                    <li class="protocol-items-li" @click="closeMenu">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/Opentrons"
                        data-gtm-category="p-header"
                        data-gtm-label="github-protocols"
                        data-gtm-action="click"
                      >Github</a>
                      <span
                        class="protocol-items-span"
                      >Contribute to open source protocol repository</span>
                    </li>
                  </div>
                </div>
                <div @click="closeMenu">
                  <a
                    class="blue"
                    href="https://opentrons.com/request-protocol"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-gtm-category="p-header"
                    data-gtm-label="request-protocol-protocols"
                    data-gtm-action="click"
                  >Request a free custom protocol ›</a>
                </div>
              </ul>
            </li>
            <li class="main-menu-li" @click="toggleMenu(`sns`), isActive(`sns`)">
              <span class="menu-span" :class="{notActive: active.sns}">Support &amp; Sales</span>
              <ul class="navbar-ul protocol-nav sns" id="sns" :class="{visible: !nav.sns}">
                <!-- <span>SUPPORT</span> -->
                <div class="navbar-ul-li">
                  <div class="protocol-items">
                    <li @click="closeMenu">
                      <span class="support-sales">SUPPORT</span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.opentrons.com/guide-for-getting-started-with-the-ot-2"
                        data-gtm-category="p-header"
                        data-gtm-label="start-guide"
                        data-gtm-action="click"
                      >OT-2 Start Guide</a>
                      <span>You received your robot, here's what's next</span>
                    </li>
                    <li @click="closeMenu">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.opentrons.com/"
                        data-gtm-category="p-header"
                        data-gtm-label="product-help"
                        data-gtm-action="click"
                      >Product Help</a>
                      <span>Answer common technical questions</span>
                    </li>
                    <li @click="closeMenu" class="github">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/Opentrons"
                        data-gtm-category="p-header"
                        data-gtm-label="github-support"
                        data-gtm-action="click"
                      >Github</a>
                      <span>Contribute to open source protocol repository</span>
                    </li>
                  </div>
                </div>
                <div class="navbar-ul-li">
                  <div class="protocol-items">
                    <li @click="closeMenu">
                      <span class="support-sales"></span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://labware.opentrons.com/"
                        data-gtm-category="p-header"
                        data-gtm-label="labware-library"
                        data-gtm-action="click"
                      >Labware Library</a>
                      <span>
                        Understand what labware is compatible with the
                        OT-2
                      </span>
                    </li>
                    <li @click="closeMenu">
                      <span class="support-sales"></span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy"
                        data-gtm-category="p-header"
                        data-gtm-label="return_policy"
                        data-gtm-action="click"
                      >Warranty &amp; Returns</a>
                      <span>
                        100% risk free returns and a quality-backed
                        warranty
                      </span>
                    </li>
                    <li @click="closeMenu">
                      <a
                        href="https://opentrons.com/ot-app"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="ot-app"
                        data-gtm-action="click"
                      >Install the app</a>
                    </li>
                    <a
                      class="blue-text"
                      href="https://opentrons.com/contact-support"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-gtm-category="p-header"
                      data-gtm-label="contact-support"
                      data-gtm-action="click"
                    >Contact support ›</a>
                  </div>
                  <!-- <div class="number">718-999-9999</div> -->
                </div>
                <div class="navbar-ul-li order-online">
                  <div class="protocol-items">
                    <li @click="close">
                      <span class="support-sales">SALES</span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://shop.opentrons.com"
                        data-gtm-category="p-header"
                        data-gtm-label="shop"
                        data-gtm-action="click"
                      >Order online</a>
                    </li>
                    <a
                      class="blue-text"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://opentrons.com/contact"
                      data-gtm-category="p-header"
                      data-gtm-label="contact-sales"
                      data-gtm-action="click"
                    >Contact sales ›</a>
                  </div>
                  <a
                    data-gtm-category="p-header"
                    data-gtm-label="cta-demo-button"
                    data-gtm-action="click"
                    class="btn schedule-demo"
                    href="https://opentrons.com/demo"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Schedule a demo ›</a>
                  <!-- <div class="number">718-999-9999</div> -->
                </div>
              </ul>
            </li>
          </ul>
          <div class="schedule-menu desktop-schedule-menu">
            <div class="schedule-div">
              <a
                class="btn schedule-demo"
                target="_blank"
                rel="noopener noreferrer"
                href="https://opentrons.com/contact"
                data-gtm-category="p-header"
                data-gtm-label="contact-sales-primary"
                data-gtm-action="click"
              >Contact Sales</a>
            </div>
          </div>
        </div>
        <div class="div-sub-menu">
          <div class="mobile-menu" :class="{mobilemenufixed: menu, dnone: !open}">
            <ul>
              <li @click="showMenu('about')">About</li>
              <li @click="showMenu('products')">Products</li>
              <li @click="showMenu('applications')">Applications</li>
              <li @click="showMenu('protocols')">Protocols</li>
              <li @click="showMenu('sns')">Support &amp; Sales</li>
            </ul>
            <div class="menu-button" @click="close">
              <a
                class="btn"
                href="https://opentrons.com/contact"
                target="_blank"
                rel="noopener noreferrer"
                data-gtm-category="p-header"
                data-gtm-label="contact-sales-primary"
                data-gtm-action="click"
              >Contact Sales</a>
            </div>
          </div>
          <div class="sub-menu about" :class="{showmenu: mobileNav.about, dnone: !open}">
            <div class="sub-menu-div" @click="closeMenu">
              <img src="../assets/img/arrow-icon.svg" alt>
              <span>About</span>
            </div>
            <ul>
              <li @click="close">
                <a
                  href="https://opentrons.com/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="about"
                  data-gtm-action="click"
                >Mission ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/team"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="team"
                  data-gtm-action="click"
                >Our Team ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://blog.opentrons.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="blog"
                  data-gtm-action="click"
                >Blog ›</a>
              </li>
            </ul>
          </div>
          <div class="sub-menu products" :class="{showmenu: mobileNav.products, dnone: !open}">
            <div class="sub-menu-div" @click="closeMenu">
              <img src="../assets/img/arrow-icon.svg" alt>
              <span>Products</span>
            </div>
            <ul>
              <li @click="close">
                <a
                  href="https://opentrons.com/ot-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="ot-2"
                  data-gtm-action="click"
                >OT-2 Robot ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/modules"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="tempmod"
                  data-gtm-action="click"
                >OT-2 Temp Module</a>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/modules"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="magmod"
                  data-gtm-action="click"
                >OT-2 Magnetic Module ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/pipettes"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="ot-2-pipettes"
                  data-gtm-action="click"
                >OT-2 Pipettes ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://shop.opentrons.com/collections/opentrons-tips"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="tips"
                  data-gtm-action="click"
                >Pipette Tips ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://shop.opentrons.com/collections/racks-and-adapters"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="tube-racks"
                  data-gtm-action="click"
                >Racks &amp; Adapters ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://shop.opentrons.com/collections/mag-bead-kits"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="reagents"
                  data-gtm-action="click"
                >Reagents ›</a>
              </li>
              <li class="blue" @click="close">
                <a
                  @click="close"
                  class="blue"
                  href="https://shop.opentrons.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="all-products"
                  data-gtm-action="click"
                >Shop all products ›</a>
              </li>
            </ul>
          </div>
          <div
            class="sub-menu applications"
            :class="{showmenu: mobileNav.applications, dnone: !open}"
          >
            <div class="sub-menu-div" @click="closeMenu">
              <img src="../assets/img/arrow-icon.svg" alt>
              <span>Applications</span>
            </div>
            <ul>
              <li @click="close">
                <a
                  href="https://opentrons.com/pcr-sample-prep"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="prep"
                  data-gtm-action="click"
                >PCR Sample Prep ›</a>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/nucleic-acid-cleanup"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="nac"
                  data-gtm-action="click"
                >Nucleic Acid Cleanup</a>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://protocols.opentrons.com/categories/Sample%20Prep/PCR"
                  data-gtm-category="p-header"
                  data-gtm-label="qpcr"
                  data-gtm-action="click"
                >qPCR/RT-PCR ›</a>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25"
                  data-gtm-category="p-header"
                  data-gtm-label="elisa"
                  data-gtm-action="click"
                >ELISA ›</a>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://protocols.opentrons.com/categories/NGS%20Library%20Prep"
                  data-gtm-category="p-header"
                  data-gtm-label="ngs-prep"
                  data-gtm-action="click"
                >NGS Library Prep ›</a>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://protocols.opentrons.com/categories/Basic%20Pipetting"
                  data-gtm-category="p-header"
                  data-gtm-label="basic"
                  data-gtm-action="click"
                >Basic Pipetting ›</a>
              </li>
            </ul>
          </div>
          <div class="sub-menu protocols" :class="{showmenu: mobileNav.protocols, dnone: !open}">
            <div class="sub-menu-div" @click="closeMenu">
              <img src="../assets/img/arrow-icon.svg" alt>
              <span>Protocols</span>
            </div>
            <ul>
              <li @click="close">
                <a
                  href="https://opentrons.com/protocols"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="protocol-tools"
                  data-gtm-action="click"
                >Protocol Options ›</a>
                <span>Gain an overview of our protocol creation options</span>
              </li>
              <li @click="close">
                <a
                  href="https://opentrons.com/protocols/designer"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="protocol-designer"
                  data-gtm-action="click"
                >Protocol Designer ›</a>
                <span>Use our graphical user interface to design protocols</span>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://protocols.opentrons.com"
                  data-gtm-category="p-header"
                  data-gtm-label="protocol-library"
                  data-gtm-action="click"
                >Protocol Library ›</a>
                <span>Explore our open source database of protocols</span>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://docs.opentrons.com/"
                  data-gtm-category="p-header"
                  data-gtm-label="opentrons-api"
                  data-gtm-action="click"
                >Python API ›</a>
                <span>
                  Maximum customization for anyone with python and basic weblab
                  skills
                </span>
              </li>
              <li @click="close">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/Opentrons"
                  data-gtm-category="p-header"
                  data-gtm-label="github-protocols"
                  data-gtm-action="click"
                >Github ›</a>
                <span>Contribute to open source protocol repository</span>
              </li>
              <li @click="close">
                <a
                  class="blue"
                  href="https://opentrons.com/request-protocol"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-gtm-category="p-header"
                  data-gtm-label="request-protocol-protocols"
                  data-gtm-action="click"
                >Request a free custom protocol ›</a>
              </li>
            </ul>
          </div>
          <div class="sub-menu sns" :class="{showmenu: mobileNav.sns, dnone: !open}">
            <div class="sub-menu-div" @click="closeMenu">
              <div class="sns-arrow">
                <img src="../assets/img/arrow-icon.svg" alt>
              </div>
              <div class="sns-span">
                <span>Support &amp; Sales</span>
              </div>
            </div>
            <ul class="sns-ul">
              <section class="sns-sales">
                <!-- <span class="sales">SALES</span> -->
                <li @click="close">
                  <section class="sns-support-section">
                    <span class="sales-tron">SALES</span>
                    <div class="support-items">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://shop.opentrons.com"
                        data-gtm-category="p-header"
                        data-gtm-label="shop"
                        data-gtm-action="click"
                        class="order-line-mobile"
                      >Order online ›</a>
                    </div>
                  </section>
                </li>
                <li @click="close">
                  <section class="sns-support-section">
                    <span class="sales-tron mobile-contact"></span>
                    <div>
                      <a
                        class="sales-link mobile-contact-sales"
                        href="https://opentrons.com/contact"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="contact-sales"
                        data-gtm-action="click"
                      >Contact sales ›</a>
                    </div>
                  </section>
                </li>
                <li>
                  <section class="sns-support-section">
                    <span class="sales-tron"></span>
                    <div>
                      <a
                        class="sales-link schedule-demo-mobile"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="schedule-demo"
                        data-gtm-action="click"
                        href="https://opentrons.com/demo"
                      >Schedule a demo ›</a>
                    </div>
                  </section>
                </li>
              </section>
              <section class="sns-support">
                <!-- <span class="support">SUPPORT</span> -->
                <li @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron">SUPPORT</span>
                    <div class="ot-2-start-guide support-items">
                      <a
                        href="https://support.opentrons.com/guide-for-getting-started-with-the-ot-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="start-guide"
                        data-gtm-action="click"
                        class="ot-2-guide"
                      >OT-2 Start Guide ›</a>
                      <span class="ot-2-guide">You received your robot, here's what's next</span>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div class="support-items">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.opentrons.com/"
                        data-gtm-category="p-header"
                        data-gtm-label="product-help"
                        data-gtm-action="click"
                      >Product Help ›</a>
                      <span>Answer common technical questions</span>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div class="support-items">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/Opentrons"
                        data-gtm-category="p-header"
                        data-gtm-label="github-support"
                        data-gtm-action="click"
                      >Github ›</a>
                      <span>Contribute to open source protocol repository</span>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div class="support-items">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://labware.opentrons.com/"
                        data-gtm-category="p-header"
                        data-gtm-label="labware-library"
                        data-gtm-action="click"
                      >Labware Library ›</a>
                      <span>
                        Understand what labware is compatible with the
                        OT-2
                      </span>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div class="support-items">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy"
                        data-gtm-category="p-header"
                        data-gtm-label="return_policy"
                        data-gtm-action="click"
                      >Warranty &amp; Returns ›</a>
                      <span>100% risk free returns and a quality-backed warranty</span>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div class="support-items">
                      <a
                        href="https://opentrons.com/ot-app"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-gtm-category="p-header"
                        data-gtm-label="ot-app"
                        data-gtm-action="click"
                      >Install the app ›</a>
                    </div>
                  </section>
                </li>
                <li class="sns-support-li" @click="close">
                  <section class="sns-support-section ot-2">
                    <span class="sales-tron"></span>
                    <div>
                      <a
                        class="blue-text sales-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://opentrons.com/contact-support"
                        data-gtm-category="p-header"
                        data-gtm-label="contact-support"
                        data-gtm-action="click"
                      >Contact support ›</a>
                    </div>
                  </section>
                </li>
              </section>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      nav: {
        about: false,
        products: false,
        applications: false,
        protocols: false,
        sns: false
      },
      mobileNav: {
        about: false,
        products: false,
        applications: false,
        protocols: false,
        sns: false
      },
      active: {
        about: false,
        products: false,
        applications: false,
        protocols: false,
        sns: false
      },
      menu: false,
      request: null,
      protocolModal: false,
      open: false
    }
  },
  methods: {
    toggleMenu (menu) {
      Object.keys(this.nav).forEach(key => {
        if (this.nav[key] !== this.nav[menu]) {
          this.nav[key] = false
        }
      })
      this.nav[menu] = !this.nav[menu]
      window.addEventListener('scroll', this.close)
    },
    isActive (a) {
      var element = document.querySelector(`#${a}`)
      Object.keys(this.active).forEach(key => {
        this.active[key] = true
      })
      this.active[a] = !this.active[a]
      if (!element.classList.contains('visible')) {
        Object.keys(this.active).forEach(key => {
          this.active[key] = false
        })
      }
    },
    openModal (request) {
      this.protocolModal = true
      this.request = request
      if (!document.body.contains('mobile-scrolling')) {
        document.body.classList += 'mobile-scrolling'
      }
    },
    toggleOpen () {
      this.open = !this.open
      this.menu = false
      Object.keys(this.mobileNav).forEach(key => {
        this.mobileNav[key] = false
      })
      window.removeEventListener('scroll', this.close)
      if (document.body.classList.contains('mobile-scrolling')) {
        document.body.classList.remove('mobile-scrolling')
      } else {
        document.body.classList.add('mobile-scrolling')
      }
    },
    close () {
      this.menu = false
      this.open = false
      document.body.classList.remove('mobile-scrolling')
      Object.keys(this.nav).forEach(key => {
        this.nav[key] = false
      })
      Object.keys(this.mobileNav).forEach(key => {
        this.mobileNav[key] = false
      })
      Object.keys(this.active).forEach(key => {
        this.active[key] = false
      })
      window.removeEventListener('scroll', this.close)
    },
    showMenu (menu) {
      this.mobileNav[menu] = !this.mobileNav[menu]
      if (this.mobileNav[menu] === true) {
        this.menu = true
      }
    },
    closeMenu () {
      this.menu = false
      Object.keys(this.mobileNav).forEach(key => {
        this.mobileNav[key] = false
      })
    },
    // TODO(mh, 2019-04-24): remove v-click-outside module
    closeOutside () {
      if (window.innerWidth >= 1024) this.close()
    }
  }
}
</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// Navigation.vue?3cfbed04